const phoneFormat = (phone) => {
  return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
};

export default phoneFormat;
